<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(createData)" @reset.prevent="reset" >
                            <iq-card>
                                <template v-slot:headerTitle>
                                    <h4 class="card-title">{{ $t('event_manage.direct_assign_stall') }}</h4>
                                </template>
                                <template v-slot:body>
                                    <b-row>
                                        <b-col lg="6" md="6" sm="6" xs="12">
                                            <ValidationProvider name="Registration No" vid="registration_id" rules='required'>
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="name_en"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                       <span class="font-weight-bold"> {{$t('externalUser.registration_id')}}</span><span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                    id="registration_id"
                                                    v-model="formData.registration_id"
                                                    @input="registrationProfile(formData.registration_id)"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-overlay :show='loading'>
                                        <b-row>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="Organization Name" vid="org_name" rules='required'>
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="org_name"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        <span class="font-weight-bold">{{$t('externalUser.org_name')}}</span> <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                        readonly
                                                        id="org_name"
                                                        v-model="formData.org_name"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="Year"  vid='year' rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="year"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        <span class="font-weight-bold">{{$t('awareness_config.year')}}</span><span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        readonly
                                                        disabled
                                                        plain
                                                        v-model="formData.year"
                                                        :options="yearList"
                                                        id="year"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="Event Type" vid="event_type" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="event_type"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        <span span class="font-weight-bold">{{$t('awareness_config.event_type')}}</span><span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="formData.event_type_id"
                                                        id="event_type_id"
                                                        :options="eventTypeList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="Event Name" vid="event_info_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="event_info_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            <span span class="font-weight-bold">{{$t('awareness_config.event_name')}}</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="formData.event_info_id"
                                                        id="event_info_id"
                                                        :options="eventList"
                                                        @input="getEventInfo(formData.event_info_id)"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Date From" vid="form_date" rules="required">
                                                    <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="level"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    <span class="font-weight-bold"> {{$t('event_manage.from_date')}}</span><span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                        plain
                                                        id="form_date"
                                                        v-model="formData.form_date"
                                                        :placeholder="$t('event_manage.from_date')"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        disabled
                                                        >
                                                    </b-form-input>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Date To" vid="to_date" rules="required">
                                                    <b-form-group
                                                    class="row"
                                                    label-cols-sm="4"
                                                    label-for="level"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                        <span class="font-weight-bold">{{ $t('event_manage.to_date')}}</span><span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                        plain
                                                        id="to_date"
                                                        v-model="formData.to_date"
                                                        :placeholder="$t('event_manage.to_date')"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        disabled
                                                        >
                                                    </b-form-input>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="Stall Type" vid="stall_type_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="stall_type_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        <span class="font-weight-bold"> {{$t('awareness_config.stall_type')}}</span><span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="formData.stall_type_id"
                                                        id="stall_type_id"
                                                        :options="stallTypeList"
                                                        @input="getStallBasicInfo()"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                                                <ValidationProvider name="stall" vid="stall_id" rules='required'>
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="stall_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            <span class="font-weight-bold">{{ $t('awareness_config.stall_name') }} <span class="text-danger">*</span></span>
                                                        </template>

                                                        <v-select
                                                            id="stall_id"
                                                            v-model="formData.stall_assign"
                                                            :reduce="op => op.value"
                                                            multiple
                                                            :options="stallList"
                                                            label="text"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            @input="stallCount()"
                                                        >
                                                        </v-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="Rent per Stall" vid="rent_per_stall" rules='required'>
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="rent_per_stall"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                            <span class="font-weight-bold">{{$t('externalUser.rent_per_stall')}}</span> <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                        type="number"
                                                        id="rent_per_stall"
                                                        readonly
                                                        v-model="formData.rent_per_stall"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="Number of Stalls" vid="number_of_stall" rules='required'>
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="number_of_stall"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        <span class="font-weight-bold">{{$t('externalUser.number_of_stall')}}</span> <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                        type="number"
                                                        id="number_of_stall"
                                                        v-model="formData.number_of_stall"
                                                        @input="totalRentAmount(formData.number_of_stall)"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        readonly
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="freeStallType" vid="freeStallType" rules='required'>
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="freeStallType"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                            <span class="font-weight-bold">{{$t('externalUser.available')}}</span>
                                                        </template>
                                                        <b-form-input
                                                        type="number"
                                                        id="freeStallType"
                                                        v-model="freeStallType"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        readonly
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="Total Rent" vid="total_cost" rules='required'>
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="total_cost"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        <span class="font-weight-bold">{{$t('externalUser.total_rent')}}</span><span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                        id="total_cost"
                                                        readonly
                                                        v-model="formData.total_cost"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" md="6" sm="6" xs="12">
                                                <ValidationProvider name="payment Type" vid="payment_type_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="4"
                                                        label-for="payment_type_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        <span class="font-weight-bold"> {{$t('event_manage.payment_type')}}</span><span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="formData.payment_type_id"
                                                        id="payment_type_id"
                                                        :options="paymentTypeList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <template v-if="formData.payment_type_id === 2">
                                                <b-col lg="6" md="6" sm="6" xs="12">
                                                    <ValidationProvider name="Voucher No" vid="voucher_no">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="voucher_no"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            <span class="font-weight-bold">{{$t('event_manage.voucher_no')}} </span>
                                                            </template>
                                                            <b-form-input
                                                            id="voucher_no"
                                                            v-model="formData.voucher_no"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" md="6" sm="6" xs="12">
                                                    <ValidationProvider name="attachment" vid="attachment">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="attachment"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                <span class="font-weight-bold">{{$t('event_manage.attachment')}} </span>
                                                            </template>
                                                            <b-form-file
                                                                id="attachment"
                                                                accept="image/*"
                                                                v-on:change="attachmentChange"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-file>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </template>
                                        </b-row>
                                        <div class="row">
                                            <div class="col-sm-3"></div>
                                            <div class="col text-right">
                                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                &nbsp;
                                                <router-link to="direct-assign-stall" :class="'btn btn-danger text-light'">{{ $t('globalTrans.cancel') }}</router-link>
                                            </div>
                                        </div>
                                    </b-overlay>
                                </template>
                            </iq-card>
                        </b-form>
                    </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { direactAssignStore, directAssignStallShow, direactAssignUpdate, registrationWiseProfileList, assignStallStatus } from '../../api/routes'
import { helpers } from '@/mixins/helper-functions'
import flatpickr from 'flatpickr'

export default {
  mixins: [helpers],
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    if (this.$route.query.id) {
        this.getData()
    }
  },
  mounted () {
    core.index()
    flatpickr('#form_date', {})
    flatpickr('#to_date', {})
  },
  data () {
    return {
        saveBtnName: this.$route.query.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
        formData: {
            id: '',
            profile_id: '',
            registration_id: '',
            year: new Date().getFullYear(),
            event_type_id: 0,
            event_info_id: 0,
            form_date: '',
            to_date: '',
            number_of_stall: '',
            stall_type_id: 0,
            stall_assign: [],
            rent_per_stall: '',
            total_cost: '',
            payment_type_id: 0,
            voucher_no: '',
            attachment: '',
            user_id: 0
        },
        awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
        stallList: [],
        stallTypeList: [],
        eventListData: [],
        freeStallType: 0,
        loading: false,
        stallDataList: '',
        paymentTypeList: [
            { value: 2, text: this.$i18n.locale === 'en' ? 'Check Payment' : 'পেমেন্ট চেক' },
            { value: 3, text: this.$i18n.locale === 'en' ? 'Cash Payment' : 'নগদে টাকা প্রদান' }
        ]
    }
  },
  computed: {
    eventList: function () {
      const listObject = this.eventListData
      const tmpList = listObject.map((obj, index) => {
        if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: this.$i18n.locale === 'en' ? obj.text_en : obj.text_bn, text_en: obj.text_en, text_bn: obj.text_bn }
        } else {
            return { value: obj.value, text: this.$i18n.locale === 'en' ? obj.text_en : obj.text_bn, text_en: obj.text_en, text_bn: obj.text_bn }
        }
      })
      return tmpList
    },
    yearList () {
        return helpers.getYearList()
    },
    eventTypeList: function () {
        return this.$store.state.AwarenessEventService.commonObj.eventTypeList.filter(item => item.status === 1)
    }
  },
  watch: {
    'formData.event_type_id': function (newVal, oldVal) {
        this.getEventList(newVal)
    },
    'formData.event_info_id': function (newVal, oldVal) {
        this.getAssignStallType()
    }
  },
  methods: {
    async getStalDetail (Id) {
        this.loadingStall = true
        const resultData = await RestApi.getData(awarenessEventServiceBaseUrl, 'stall-participant/apply-stall/stall-info/' + Id + '/' + this.formData.event_info_id)
        this.freeStallType = resultData.freeStallType
        this.loadingStall = false
    },
    stallCount () {
        this.formData.number_of_stall = this.formData.stall_assign.length
        this.formData.total_cost = this.formData.rent_per_stall * this.formData.number_of_stall
    },
    async getData () {
        const resultData = await RestApi.getData(awarenessEventServiceBaseUrl, directAssignStallShow + '/' + this.$route.query.id)
        const temData = resultData.data
        const assignStall = []
        temData.stall_assign_details.map(item => {
            assignStall.push(item.stall_detail_id)
        })
        temData.stall_assign = assignStall
        this.formData = temData
    },
    attachmentChange (e) {
      this.tmpAttachment = e.target.files[0]
    },
    async createData () {
        if (parseInt(this.freeStallType) < parseInt(this.formData.number_of_stall)) {
            this.$swal({
                title: this.$t('externalUser.number_of_stalls_is_more_than_available_stalls'),
                showCancelButton: false,
                focusConfirm: false
            }).then((resultSwal) => {
                if (resultSwal.isConfirmed) {
                    return false
                }
            })
            return false
        }
        this.loading = true
        this.$store.dispatch('mutateCommonProperties', { loading: true })
        let result = null
        const loadinState = { loading: false, listReload: true }
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        var formData = new FormData()
        Object.keys(this.formData).map(key => {
            if (key === 'attachment') {
                formData.append(key, this.tmpAttachment)
            } else {
                formData.append(key, this.formData[key])
            }
        })
        formData.append('stall_assign', JSON.stringify(this.formData.stall_assign))
        if (this.$route.query.id) {
            formData.append('_method', 'PUT')
            result = await RestApi.postData(awarenessEventServiceBaseUrl, `${direactAssignUpdate}/${this.$route.query.id}`, formData)
        } else {
            result = await RestApi.postData(awarenessEventServiceBaseUrl, direactAssignStore, formData, config)
        }

        this.$store.dispatch('mutateCommonProperties', loadinState)

        if (result.success) {
            this.loading = false
            this.$store.dispatch('AwarenessEventService/mutateCommonObj', { hasDropdownLoaded: false })
            this.$toast.success({
            title: this.$t('globalTrans.success'),
            message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
            })
            this.$router.push('/awareness-event-service/event-management-system/direct-assign-stall')
            if (result.notification && this.$store.state.emitNotification) {
                this.$socket.emit('send-notification', result.notification)
            }
        } else {
            this.loading = false
            this.$refs.form.setErrors(result.errors)
        }
    },
    async registrationProfile () {
        this.loading = true
        const param = this.formData.registration_id
        const result = await RestApi.getData(awarenessEventServiceBaseUrl, `${registrationWiseProfileList}/${param}`)
        if (result.success) {
            this.formData.year = result.data.year
            this.formData.profile_id = result.data.id
            this.formData.org_name = result.data.org_name
            this.formData.org_name_bn = result.data.org_name_bn
            this.formData.user_id = result.data.user_id
        } else {
            this.formData.year = ''
            this.formData.profile_id = ''
            this.formData.org_name = ''
            this.formData.org_name_bn = ''
            // this.$toast.error({
            //     title: 'error',
            //     message: result.message,
            //     color: '#D6E09B'
            // })
        }
        this.loading = false
    },
    async getStallBasicInfo () {
        this.formData.stall_assign = []
        this.getAssignStall()
        this.getStallInfo()
        this.getStalDetail(this.formData.stall_type_id)
    },
    async getAssignStall () {
        this.loading = true
        const dataSend = {
            stall_type_id: this.formData.stall_type_id,
            event_type_id: this.formData.event_type_id,
            event_info_id: this.formData.event_info_id,
            year: this.formData.year,
            id: this.formData.id
        }
        const result = await RestApi.getData(awarenessEventServiceBaseUrl, assignStallStatus, dataSend)
        if (result.success) {
            const stallList = result.data.map((obj, index) => {
                return Object.assign({}, obj, {
                    text: this.$i18n.locale === 'en' ? obj.text_en : obj.text_bn
                })
            })
            this.stallList = stallList
        } else {
            this.stallList = []
        }
        this.loading = false
    },
    async getAssignStallType () {
        const dataSend = {
            stall_type_id: this.formData.stall_type_id,
            event_type_id: this.formData.event_type_id,
            event_info_id: this.formData.event_info_id,
            year: this.formData.year
        }
        const result = await RestApi.getData(awarenessEventServiceBaseUrl, 'event-management/direct-assign-stall/free-stall-type', dataSend)
        if (result.success) {
            const stallTypeList = result.data.map((obj, index) => {
                return Object.assign({}, obj, {
                    text: this.$i18n.locale === 'en' ? obj.text_en : obj.text_bn
                })
            })
            this.stallTypeList = stallTypeList
        } else {
            this.stallTypeList = []
        }
        this.loader = false
    },
    async getEventList () {
        const dataSend = {
            event_type_id: this.formData.event_type_id,
            event_info_id: this.formData.event_info_id,
            year: this.formData.year
        }
        const result = await RestApi.getData(awarenessEventServiceBaseUrl, 'event-management/direct-assign-stall/event-list', dataSend)
        if (result.success) {
            this.eventListData = result.data
        } else {
            this.eventListData = []
        }
    },
    getEventInfo (Id) {
        const evenList = this.$store.state.AwarenessEventService.commonObj.eventList.filter(item => item.status === 1)
        if (Id) {
            const data = evenList.find(data => data.value === Id)
            this.formData.form_date = data.start_date
            this.formData.to_date = data.end_date
        }
    },
    async getStallInfo () {
        this.loading = true
        const fairStallList = this.$store.state.AwarenessEventService.commonObj.fairStallList.filter(item => item.status === 1)
        if (this.formData.stall_type_id) {
            const data = fairStallList.find(data => data.stall_type_id === this.formData.stall_type_id)
            this.formData.rent_per_stall = data.fee
        } else {
            this.formData.rent_per_stall = 0
        }
        this.loading = false
    },
    totalRentAmount (Id) {
        this.formData.total_cost = this.formData.rent_per_stall * Id
    },
    getStallList (stallTypeId) {
        return this.$store.state.AwarenessEventService.commonObj.stallList.filter(item => item.value && item.stall_type_id === stallTypeId)
    }
  }
}
</script>
